exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.step1[data-v-870cc2de] {\n  width: 9.85rem;\n  left: 8.25rem;\n  top: 5.9rem;\n  z-index: 99999;\n}\n.step2[data-v-870cc2de] {\n  width: 8.95rem;\n  left: 6.915rem;\n  top: 23.55rem;\n  z-index: 99999;\n}\n.share[data-v-870cc2de] {\n  width: 8.85rem;\n  right: 0.5rem;\n  top: 0.5rem;\n  z-index: 99999;\n}", ""]);

// exports
